//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../../../axios/axios.js'
import ItemsSearchField from '../../../../../components/Field/ItemsSearchField.vue'
import CardSeparator from '../../../../../components/Card/CardSeparator.vue'
import { createFieldConfig } from '../../../../../components/QSelectUtils.js'
import BrigadeAutoAssignWorkTypes from './BrigadeAutoAssignWorkTypes.vue'

export default {
  components: {
    ItemsSearchField,
    BrigadeAutoAssignWorkTypes,
    CardSeparator
  },
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    requestTypes: {
      type: Array,
      default () {
        return []
      }
    },
    excludeRequestTypes: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    anyWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    anyWorkTypeFromAnyWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    anyWorkTypeFromAllWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    anyWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    excludeWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    excludeWorkPackages: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      requestTypesFieldConfig: createFieldConfig({ allRecordsFn: this.getAvailableRequestTypes }),
      excludeRequestTypesFieldConfig: createFieldConfig({ allRecordsFn: this.getAvailableRequestTypes }),
      availableRequestTypes: null,
      availableWorkTypes: null,
      availableWorkPackages: null
    }
  },
  computed: {
    brigadeWorkAreasIds: function () {
      return this.brigade ? [
        ...(this.brigade.workAreas || []).map(this.getWorkAreaId),
        ...(this.brigade.redirectedWorkAreas || []).map(this.getWorkAreaId)
      ] : []
    }
  },
  watch: {
    brigadeWorkAreasIds: function () {
      // Доступные значения будут перезачитаны
      this.availableRequestTypes = null
      this.availableWorkTypes = null
      this.availableWorkPackages = null
    }
  },
  methods: {
    getAvailableRequestTypes: function () {
      if (this.availableRequestTypes) {
        return this.availableRequestTypes
      } else {
        return this.loadAvailableRequestTypes()
      }
    },
    getAvailableWorkTypes: function () {
      if (this.availableWorkTypes) {
        return this.availableWorkTypes
      } else {
        return this.loadAvailableWorkTypes()
      }
    },
    getAvailableWorkPackages: function () {
      if (this.availableWorkPackages) {
        return this.availableWorkPackages
      } else {
        return this.loadAvailableWorkPackages()
      }
    },
    getWorkAreaId: function (workArea) {
      return workArea != null && typeof workArea === 'object' ? workArea.id : workArea
    },
    loadAvailableRequestTypes: function () {
      return axiosGet({
        url: '/service/delta/brigade/getRequestTypes?workAreas=' + this.brigadeWorkAreasIds.join(','),
        // url: '/service/obj/search?type=workType&returnFields=id,name&start=0&limit=1000000',
        onSuccess: (response) => {
          this.availableRequestTypes = response.data.result
          return response.data.result
        },
        onFailure: 'Ошибка получения списка доступных для выбора работ',
        msgTarget: this
      })
    },
    loadAvailableWorkTypes: function () {
      return axiosGet({
        url: '/service/delta/brigade/getWorkTypes?workAreas=' + this.brigadeWorkAreasIds.join(','),
        // url: '/service/obj/search?type=workType&returnFields=id,name&start=0&limit=1000000',
        onSuccess: (response) => {
          this.availableWorkTypes = response.data.result
          return response.data.result
        },
        onFailure: 'Ошибка получения списка доступных для выбора работ',
        msgTarget: this
      })
    },
    loadAvailableWorkPackages: function () {
      return axiosGet({
        url: '/service/delta/brigade/getWorkPackages?workAreas=' + this.brigadeWorkAreasIds.join(','),
        // url: '/service/obj/search?type=workPackage&returnFields=id,name&add=workType&start=0&limit=1000000',
        onSuccess: (response) => {
          this.availableWorkPackages = response.data.result
          return response.data.result
        },
        onFailure: 'Ошибка получения списка доступных для выбора комплексов работ',
        msgTarget: this
      })
    }
  }
}

